'use strict';
module.exports = function (item) {
    var content = item[1];
    var cssMapping = item[3];
    if (!cssMapping) {
        return content;
    }
    if (typeof btoa === 'function') {
        var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
        var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,'.concat(base64);
        var sourceMapping = '/*# '.concat(data, ' */');
        return [content].concat([sourceMapping]).join('\n');
    }
    return [content].join('\n');
};